
import { defineComponent } from "vue";
import Menu from "@/components/menu.vue"; // @ is an alias to /src
import { mapState } from "vuex";
import api from "@/api";


function makeid(length:any) {
   var result           = '';
   var characters       = 'abcdef0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

export default defineComponent({
  name: "Avatar",
  components: {
    Menu
  },
  data(){
    return {
        g_link : 'https://buy.stripe.com/fZe3dT5hkdVs8ZqcN4'
    }
  },
  mounted(){


    let k = localStorage.getItem('location_thing')
    if (k == 'Russia'){
      this.$data.g_link = 'https://portret.ai/ru#myprice'
    }
    api.avatars(1).then((data)=>{
      console.log('avatars');
      console.log(data);
      this.$store.commit('set_avatars', data.data)

    })

  },
  methods: {
  },
  computed: {
    ...mapState({
      email: (state: any) => state.email,
      prompts: (state: any) => state.prompts,
      status: (state: any) => state.status,
      paid: (state: any) => state.paid,
      photos: (state: any) => state.photos,
      avatars: (state: any) => state.avatars
    })
  },
});
